// This file was automatically generated from appchart.dialog.addEditProblem.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.addEditProblem');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.imo');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addEditProblem.form = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="overlayContainer"><div class="el8SourceProblemSection source-problem-section"></div><div class="el8SourceCodesSection source-codes-section"></div><div class="el8TermListSection term-list-section">');
  if (opt_data.hccScoringEnabled) {
    el8.template.appshared.imo.termListHeaderWithHCC({mindreader: false}, output);
  } else {
    el8.template.appshared.imo.termListHeader({mindreader: false}, output);
  }
  output.append('<div class="term-list"></div><div class="mt5 add-trigger-section"><a class="add-trigger">+ Add Another Dx</a></div></div><div class="el8TermSearchSection term-search-section"><div class="el8TermSearchLine"><div class="el8TermSearchCaption">Search for a Diagnosis:</div><div class="el8TermSearchCaptionHelp"><a href="https://help.elationhealth.com/s/article/managing-your-problem-list" target="_blank" rel="noopener">?</a></div></div><div id="add-edit-problem-dx-nav" class="m5" style="display: none;"></div><div class="el8TextareaWrap" style="display: none;"><input class="w100 info-field mr-input-field el8InfoText" name="query" spellcheck="false" autocomplete="off" _infotext="Start typing a description or code (ICD-10, ICD-9, SNOMED)" maxlength="100"></div></div><form id="add-edit-problem-form"><div class="el8FieldSection"><label class="el8label el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Title</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="description"></textarea></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong el8FieldRequired"><span class="el8FieldSection"><span class="el8RequiredStyle">*</span>Dx Date</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap w25"><input type="text" class="w87" name="startDate" /></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong">Status:</label><div class="el8FieldLongLabelPadding el8Wrap"><div class="w100">');
  var statusList1047 = opt_data.statusChoices;
  var statusListLen1047 = statusList1047.length;
  for (var statusIndex1047 = 0; statusIndex1047 < statusListLen1047; statusIndex1047++) {
    var statusData1047 = statusList1047[statusIndex1047];
    output.append('<label class="el8label el8Radio mr10"><input type="radio" name="status" value="', soy.$$escapeHtml(statusData1047), '"', (statusData1047 == 'Active') ? 'checked' : '', '><span class="el8LeftIndent">', soy.$$escapeHtml(statusData1047), '</span></input></label>');
  }
  output.append('</div></div></div><div class="el8FieldSection"><label class="el8label el8FieldLong"><span class="el8FieldSection">Synopsis</span></label><div class="el8FieldLongLabelPadding el8TextareaWrap"><textarea type="text" class="w100" name="details"></textarea></div></div></form></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addEditProblem.mindreaderContainer = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog"><div class="mr-dropdown-content el8MRContainer"><div class="mr-results-info el8MRInformTextIMO"></div><div class="mr-results padb10"></div><div class="mr-bottom-text el8MRFloatingBottomContainer">Powered by IMO&reg; Terminology. &copy;1995–2015 Intelligent Medical Objects, Inc. All Rights Reserved</div></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addEditProblem.term = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TermList ', (opt_data.mindreader) ? 'el8TermListMR' : '', ' term-item"', (opt_data.term.imo_code) ? ' data-imo-code="' + soy.$$escapeHtml(opt_data.term.imo_code) + '" ' : '', (opt_data.term.id) ? 'data-id="' + soy.$$escapeHtml(opt_data.term.id) + '"' : '', '><div class="el8TermListProblem">', soy.$$escapeHtml(opt_data.term.title), '</div><div class="el8TermListIcd10">');
  if (opt_data.mindreader) {
    output.append(soy.$$escapeHtml(opt_data.term.icd10), (opt_data.term.more_icd10) ? '+' : '');
  } else {
    var icd10List1087 = opt_data.term.icd10s;
    var icd10ListLen1087 = icd10List1087.length;
    for (var icd10Index1087 = 0; icd10Index1087 < icd10ListLen1087; icd10Index1087++) {
      var icd10Data1087 = icd10List1087[icd10Index1087];
      output.append('<div data-code="', soy.$$escapeHtml(icd10Data1087), '">', soy.$$escapeHtml(icd10Data1087), '</div>');
    }
  }
  output.append('</div><div class="el8TermListIcd9">');
  if (opt_data.mindreader) {
    output.append((opt_data.term.icd9) ? soy.$$escapeHtml(opt_data.term.icd9) : '', (opt_data.term.more_icd9) ? '+' : '');
  } else {
    var icd9List1104 = opt_data.term.icd9s;
    var icd9ListLen1104 = icd9List1104.length;
    for (var icd9Index1104 = 0; icd9Index1104 < icd9ListLen1104; icd9Index1104++) {
      var icd9Data1104 = icd9List1104[icd9Index1104];
      output.append('<div data-code="', soy.$$escapeHtml(icd9Data1104), '">', soy.$$escapeHtml(icd9Data1104), '</div>');
    }
  }
  output.append('</div>', (! opt_data.mindreader) ? '<div class="el8TermListSnomed"><div data-code="' + soy.$$escapeHtml(opt_data.term.snomed) + '">' + soy.$$escapeHtml(opt_data.term.snomed) + '</div></div><div class="el8TermListRemove el8Relative"><a class="term-remove-trigger el8RemoveButton"></a></div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addEditProblem.legacyTerm = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8TermList ', (opt_data.mindreader) ? 'el8TermListMR' : '', ' term-item"', (opt_data.term.id) ? 'data-id="' + soy.$$escapeHtml(opt_data.term.id) + '"' : '', '><div class="el8TermListProblem">', soy.$$escapeHtml(opt_data.term.description), '</div><div class="el8TermListIcd10"><span class="el8999">n/a</span></div><div class="el8TermListIcd9">', soy.$$escapeHtml(opt_data.term.code), '</div>', (! opt_data.mindreader) ? '<div class="el8TermListSnomed"><span class="el8999">n/a</span></div><div class="el8TermListRemove el8Relative"><a class="term-remove-trigger el8RemoveButton"></a></div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addEditProblem.sourceProblem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><span class="el8777">Source: </span><span class="el8Medium">', soy.$$escapeHtml(opt_data.description), '</span></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.addEditProblem.tooltip = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8CodeTooltipWrap"><div class="el8CodeTooltipCodeLine">', soy.$$escapeHtml(opt_data.code), ' (', soy.$$escapeHtml(opt_data.codeType), ')</div>', (opt_data.description) ? '<div class="el8CodeTooltipDescription">' + soy.$$escapeHtml(opt_data.description) + '</div>' : '', '</div>');
  if (!opt_sb) return output.toString();
};
